module.exports = __webpack_public_path__ + "static/media/transparent-background-light-bulb.8614e634.png";